
import showdown from "showdown" 

export default function(o, done){

  var type = 'licence'

  var label = o.util.getTranslation(o, type)

  document.title = `Open Memory Box | ${label}`

  var lang = o.store('lang')

  var converter = new showdown.Converter({
    simpleLineBreaks: true,
    openLinksInNewWindow: true,
  })

  o.data.content(o, function(contentData){

    var content = _.find(contentData, {view: type})

    var markdown = content[lang]

    var html = converter.makeHtml(markdown)

    var textDiv =
      $('<div>')
      .css(o.morePagesTextCss)
      .css({
        textTransform: 'none',
      })
      .append(html)

    var div = $('<div>')
    .css(o.mainDivCss)
    .addClass('iphoneNavbarFixTop')
    .addClass('iphoneNavbarFixBottom')  
    .append([

      o.component.menu(o)
      .css({
        flex: '0 0 auto',
        width: '100%',
        zIndex: 1,
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
      }),

      $('<div>')
      .css({
        flex: '0 1 auto',
        justifyContent: 'center',
        overflowY: 'auto',
        '-webkit-overflow-scrolling': 'touch',
        minHeight: 0,
        zIndex: 1,
      })
      .html(textDiv),

      $('<div>')
      .css({
        flex: '1 1 auto',
      }),

    ])

    done(div)

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/licence/licence.js